import axios from 'axios';

export default {
  namespaced: true,
  state: {
    all: [],
  },
  getters: {},
  actions: {
    index({ commit }) {
      return axios.get(process.env.VUE_APP_API_URL + 'electrical-boxes')
        .then(({ data }) => {
          commit('setElectricalBoxes', data);
        });
    },
  },
  mutations: {
    setElectricalBoxes(state, electricalBoxes) {
        state.all = electricalBoxes;
    },
  },
};
